'use strict';

const { map } = require('underscore');

const CollectionView = require('./collection');

const QuantityView = require('./quantity');

class QuantitiesView extends CollectionView {
  constructor() {
    super(...arguments);

    this.on('select', this.select, this);
  }

  initialize() {
    this.module = 'glive_booking_redesign';
    this.templateName = 'quantities';
    this.childView = QuantityView;
  }

  events() {
    return {
      'click .left-arrow': 'clickLeftArrow',
      'click .right-arrow': 'clickRightArrow',
    };
  }

  attributes() {
    return { 'data-bhw': 'QuantityPicker' };
  }

  select(partySize) {
    this.options.selection = partySize;
    setTimeout(() => this.render(), 0);
  }

  render() {
    super.render(...arguments);
    this.offset = 0;
    this.$leftArrow = this.$el.find('.left-arrow');
    this.$rightArrow = this.$el.find('.right-arrow');
    this.$quantities = map(this.$el.find('.displayed-quantities').children(), el => $(el));
    this.updateDisplay();
  }

  clickRightArrow() {
    this.offset += 7 - this.shouldDisplayLeftArrow();
    this.updateDisplay();
  }

  clickLeftArrow() {
    this.offset -= this.offset === 7 ? 7 : 6;
    this.updateDisplay();
  }

  shouldDisplayLeftArrow() {
    return this.offset !== 0;
  }

  shouldDisplayRightArrow() {
    return this.collection.length > 8 && this.collection.length > this.offset + 7;
  }

  updateDisplay() {
    if (this.shouldDisplayLeftArrow()) {
      this.$leftArrow.addClass('display');
    } else {
      this.$leftArrow.removeClass('display');
    }
    if (this.shouldDisplayRightArrow()) {
      this.$rightArrow.addClass('display');
    } else {
      this.$rightArrow.removeClass('display');
    }

    const upperLimit = this.offset + 8 - this.shouldDisplayRightArrow() - this.shouldDisplayLeftArrow();

    this.$quantities.forEach(($el, idx) => {
      if (idx >= this.offset && idx < upperLimit) {
        $el.addClass('display');
      } else {
        $el.removeClass('display');
      }
    });
  }
}

module.exports = QuantitiesView;
